import { mark } from '@pcln/measure'
import get from 'lodash/get'
import {
  listingsIsLoading,
  setExpiredSessionTimestamp,
  listingsFetchDataSuccess,
  fetchedInitialListings,
  updateBrandReference,
  setListingsMetaData,
  displayInfiniteScrollLoadMore,
} from '../actionCreators'
import { setPriceBreakers } from '../../priceBreakers'

import { setHasExpressDeal } from '../../flags'
import { getExdCarriersGraph } from '../../../util/listingsHelpers'
import { flyGaLogic } from '../../../util/flyGaLogic'
import { canLoadMoreitins } from '../../../util/canLoadMoreitins'

import { flyDetailDeeplinkModel } from '../../../components/Legacy/fly-detail-deeplink-model/fly-detail-deeplink-model-factory'
import { genearatePriceBreakersApi } from '../../../../services/priceBreakers'
import { airSearch } from '../../../services/airSearch'
import { setDisplayCarriers } from '../../airlines'
import { handleError } from '../helpers/handleError/handleError.js'
import { errorCoding } from '../../../../common/BackendErrorCoding/errorCoding'
import { logSearchError } from '../../../util/clientLogger'
import { setInitialFilterInfo, updateIncludedCarriers } from '../../filters'
import { pclnExpt } from '../../../../common/fly-experimentation/fly-experimentation'
import { getPageNumber } from '../../../util/getPageNumber'
import { PERF_EVENTS } from '../../../../common/constants/perfEvents'
import { flySearchResponseData } from '../../../models/FlySearchResponseModel'
import { airSearchRequestModel } from '../../../services/airSearch/airSearchRequest'
import { getIsSbs } from '../../../util/sbs'

/**
 * Load initial set of listings
 * @returns {function(*, *)}
 */
export function fetchAirSearchResponse(
  pclnBootstrapData,
  SETI,
  airSearchPromise,
  attributeFilterConditions
) {
  return (dispatch, getState) => {
    dispatch(listingsIsLoading(true))
    dispatch(setExpiredSessionTimestamp())

    const deeplink = flyDetailDeeplinkModel.get() // TODO: DO we need this

    if (deeplink.token) {
      deeplink.airSearchReturned = false

      flyDetailDeeplinkModel.set(deeplink)
    } else {
      flyGaLogic.fire.airSearchCallInitiated()
    }

    flyGaLogic.startTimer('airSearch')

    return runAirSearchPromise()

    function runAirSearchPromise(sessKeySearchFailed) {
      // Use promise if defined, otherwise fire new airSearch call

      const activeTabId = getState().activeTabId

      const promise =
        airSearchPromise ||
        airSearch({
          pclnBootstrapData,
          SETI,
          sessKeySearchFailed,
          activeTabId,
        })

      return promise
        .then(res => {
          const { response } = res
          // Note: this only fires when we get a successful API response (does not include zero-itins returned)
          flyGaLogic.fire.initialListingsRendering('started')

          const {
            airports = {},
            airlines = {},
            listingsMetaData = {},
            filterDefaults = {},
            brandReference = [],
            priceGuidance = {},
            listings,
            displayableCarriers,
          } = response

          const {
            searchSessionKey,
            clientSessionId,
            minVoidWindowClose,
            hasAirCanada: isAirCanada,
            hasExpressDeal,
            tripType,
            totalItineraries,
            totalFilteredItineraries,
            upperBound,
          } = listingsMetaData

          if (res && attributeFilterConditions) {
            pclnExpt.fireImpression('AIR_LISTINGS_ATTRIBUTE_FILTER_CACHED')
          }

          /**
           * Set the Initial STATIC Data here before dispatching any redux events
           * */

          let exdCarriers = []

          if (displayableCarriers) {
            exdCarriers = getExdCarriersGraph(displayableCarriers, airlines)
          }

          pclnExpt.fireImpression('AIR_LISTINGS_AD_CLICK_OFF')
          if (tripType !== 'MD') {
            pclnExpt.fireImpression('AIR_SEARCH_LISTINGS_COVID_ASSURANCE')
          }

          if (tripType === 'MD') {
            pclnExpt.fireImpression('AIR_LISTINGS_MD_AIRPORT_FILTERS')
          }

          const filterableSliceData = {}

          // eslint-disable-next-line no-unused-expressions
          filterDefaults?.TIME?.forEach(sliceSummary => {
            filterableSliceData[sliceSummary.sliceRefId] = sliceSummary
          })

          // Singleton to store initial response objects
          Object.assign(flySearchResponseData, {
            airports,
            airlines,
            searchSessionKey,
            clientSessionId,
            filterDefaults,
            filterableSliceData,
            priceGuidance,
            exdCarriers, // TODO: Merge this node with EXD Response node
          })

          // we have fetched all that we can fetch, don't fetch any more
          const loadMore = canLoadMoreitins(
            upperBound,
            totalFilteredItineraries
          )

          // AIR-22222 GA tag number of returned itineraries from listings call
          flyGaLogic.fire.numOfItinerariesReturned(totalItineraries)

          // Send Air Search Response Time
          _logResponseTime(response)

          // handle results - start
          handleSearchResults(response)
          // handle results - end

          /**
           * TODO: Refactor this abomination after the Graph Win
           */
          const listingsObj = {
            response: response.listings,
            minVoidWindowClose,
            isAirCanada,
          }

          const isSBS = getIsSbs()

          dispatch(listingsIsLoading(false))
          // TODO: Not needed for Redux state - REfactor this
          dispatch(setDisplayCarriers(displayableCarriers || []))
          dispatch(setListingsMetaData(get(response, 'listingsMetaData', null)))
          /**
           * TODO: Refactor this abomination after the Graph Win
           */
          dispatch(setHasExpressDeal(hasExpressDeal))
          if (brandReference) {
            dispatch(updateBrandReference(brandReference))
          }
          dispatch(displayInfiniteScrollLoadMore(loadMore))
          dispatch(listingsFetchDataSuccess(listingsObj))
          dispatch(fetchedInitialListings(true))
          mark(PERF_EVENTS.transformGraphAirSearchRspEnd)

          // Set Filter Defaults
          dispatch(setInitialFilterInfo(filterDefaults, { isSBS, activeTabId }))
          if (
            get(
              pclnBootstrapData,
              'searchRequest.params[included-airlines]',
              ''
            )
          ) {
            dispatch(
              updateIncludedCarriers(
                get(
                  pclnBootstrapData,
                  'searchRequest.params[included-airlines]',
                  ''
                )
              )
            )
          }

          // const callPriceBreakers = tripType !== 'MD' && false
          const callPriceBreakers = false

          let priceBreakersMeta

          /**
           * Make the Price Breakers call as soon as User receives a EXD
           * */
          if (callPriceBreakers) {
            if (listings[0].isExpressDeal && !listings[0].exdOpenJaw) {
              const {
                groupId,
                refId,
                token,
              } = listings[0].itineraryReferenceInfo
              const originAirportCode =
                listings[0]?.slice?.[0]?.originAirportCode
              const destinationAirportCode =
                listings[0]?.slice?.[0]?.destinationAirportCode

              priceBreakersMeta = {
                groupId,
                refId,
                token,
                originAirportCode,
                destinationAirportCode,
              }
            }

            if (priceBreakersMeta) {
              genearatePriceBreakersApi({
                pclnBootstrapData,
                SETI,
                // flySearchRequestModel: flySearchRequestModel.get(),
                priceBreakersMeta,
              })
                .then(res => {
                  if (res?.priceBreakersResponse?.priceBreakersSessionKey) {
                    dispatch(setPriceBreakers(res.priceBreakersResponse))
                  }
                })
                .catch(error => {
                  logSearchError('Build Price Breakers API', error)
                })
            }
          }

          return null
        })
        .catch(e => {
          if (e.code === errorCoding.BAD_SESSION_KEY.code) {
            runAirSearchPromise(true)
            logSearchError('sessionKeyAirSearchDisplayReq', e)
          } else {
            handleError(dispatch, e, 'INITIAL')
          }
        })
    }
  }
}

function _logResponseTime(response) {
  if (get(response, 'pricedItineraryTable')) {
    flyGaLogic.endTimer('airSearch')
    const timerResult = flyGaLogic.retrieveTimer('airSearch')
    const searchResultTime = Math.round(timerResult.secondsTime)
    flyGaLogic.fire.responseTime(searchResultTime, 'airSearch')
  } else {
    flyGaLogic.endTimer('airSearch')
    flyGaLogic.fire.responseTime(null, 'airSearch')
  }
}

function handleSearchResults(response) {
  const deeplink = flyDetailDeeplinkModel.get() // TODO: DO we need this

  const { listingsMetaData, listings } = response

  const { tripType, upperBound } = listingsMetaData

  // Send Displayed
  if (!deeplink.token) {
    deeplink.airSearchReturned = true
    flyGaLogic.fire.airSearchCallDisplayed()
  }
  const firstItinerary = response.listings[0]
  if (
    firstItinerary &&
    !firstItinerary.isExpressDeal &&
    firstItinerary.isFused
  ) {
    flyGaLogic.fire.splitLowestPriceFullResult(
      tripType,
      !!firstItinerary.isFused,
      firstItinerary.interline
    )
  }

  airSearchRequestModel.setSearchId({
    searchId: response.listingsMetaData.searchId,
  })
  airSearchRequestModel.setSearchSessionKey({
    searchSessionKey: response.listingsMetaData.searchSessionKey,
  })

  if (listings && listings.length > 0) {
    if (listings[0].isExpressDeal) {
      flyGaLogic.fire.airSearchResponse(
        'Success with express deal candidates',
        tripType
      )
    } else {
      flyGaLogic.fire.airSearchResponse(
        'Success without express deal candidates',
        tripType
      )
    }
  }

  flyGaLogic.fire.viewMoreFlights(
    getPageNumber({ itinerariesIndex: upperBound })
  )
}
